// extracted by mini-css-extract-plugin
export default {"PrimaryButton":"PrimaryButton_PrimaryButton__Rj0xG","spinner":"PrimaryButton_spinner__1cFKg"};